import { useState } from "react"
import { Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { StandardDialog } from "../../../../../shared/components/dialogs/StandardDialog"
import { StandardButton } from "../../../../../shared/components/buttons/StandardButton"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { CreateUpdateMessageForm } from "../../../../merchant/admin/messages/components/CreateUpdateMessageForm"
import { CreateMessageSuccessDialog } from "../../../../merchant/admin/messages/components/CreateMessageSuccessDialog"
import { useCreateServiceCenterMessageFlow } from "./serviceCenterMessagesHooks"
import { SERVICE_CENTER_CHANNEL_OPTIONS } from "../serviceCenterChannelOptions"
import { SERVICE_CENTER_MESSAGES_ROUTE } from "../../../../../constants/routes"

const useStyles = makeStyles()(() => ({
    button: {
        paddingLeft: "5rem",
        paddingRight: "5rem",
    },
}))
type Step = "form" | "success"

type ServiceCenterCreateMessageDialogProps = {
    open: boolean
    onClose: () => void
}

export function ServiceCenterCreateMessageDialog({ onClose }: ServiceCenterCreateMessageDialogProps) {
    const { classes } = useStyles()

    const [step, setStep] = useState<Step>("form")

    const handleCreateSuccess = () => {
        setStep("success")
    }

    const { formRef, handleSaveClick, handleSubmit } = useCreateServiceCenterMessageFlow(handleCreateSuccess)

    const isFormStep = step === "form"

    return (
        <>
            {isFormStep ? (
                <StandardDialog
                    open={isFormStep}
                    onClose={onClose}
                    maxWidthProp="xl"
                    dialogTitle={
                        <LocalizedStrict id="top-bar-new-menu-push-message-dialog-title">
                            <>New push message</>
                        </LocalizedStrict>
                    }
                >
                    <Stack gap="1.5rem" padding="1.5rem" paddingTop="0">
                        <CreateUpdateMessageForm
                            ref={formRef}
                            location="dialog"
                            mode="create"
                            channelOptions={SERVICE_CENTER_CHANNEL_OPTIONS}
                            defaultChannels={[]}
                            onSubmit={handleSubmit}
                        />
                        <Stack direction="row" justifyContent="center">
                            <LocalizedStrict id="create-message-save-button">
                                <StandardButton
                                    fullWidth={false}
                                    updateDefaultClasses={classes.button}
                                    type="submit"
                                    onClick={handleSaveClick}
                                >
                                    Create
                                </StandardButton>
                            </LocalizedStrict>
                        </Stack>
                    </Stack>
                </StandardDialog>
            ) : (
                <CreateMessageSuccessDialog
                    open={!isFormStep}
                    onClose={onClose}
                    messagesRoute={SERVICE_CENTER_MESSAGES_ROUTE}
                />
            )}
        </>
    )
}
